import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {StringUtils} from "components/src/utils/StringUtils";
import {Check as CheckIcon, Copy as CopyIcon} from "iconoir-react";
import {useState} from "react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Placement} from 'react-bootstrap/types';
import "./Truncate.scss";

interface TruncateProps {
    value? : string
    maxLength : number
    placement?: Placement
    className? : string
}

export const Truncate = ({value, maxLength, placement = "top", className} : TruncateProps) =>
{
    /**
     * Set to true for a short while after the value is copied to the clipboard
     */
    const [copied, setCopied] = useState<boolean>(false);

    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    if (value === undefined || value === null || value.length < maxLength)
    {
        return (
            <span className={className}>{value}</span>
        )
    }
    else {
        return (
            <OverlayTrigger
                placement={placement}
                overlay={
                    <Tooltip>
                        {value}
                    </Tooltip>
                }
            >
                <span className="truncate-copy-wrapper">
                    <span className={className}>{StringUtils.truncate(value, maxLength)}</span>
                    <button
                        type="button"
                        className="truncate-copy btn btn-link p-0 border-0 lh-1"
                        title={t('common.copy-to-clipboard-title')}
                        aria-label={t('common.copy')}
                        onClick={(e) => {
                            // Prevent the copy click from triggering a parent onClick (e.g. row navigation)
                            e.stopPropagation();
                            e.preventDefault();

                            // Copy the full value, not the truncated text
                            void navigator.clipboard.writeText(value);

                            setCopied(true);
                            setTimeout(() => setCopied(false), 1500);
                        }}>
                        {copied ? <CheckIcon className="text-success"/> : <CopyIcon/>}
                    </button>
                </span>
            </OverlayTrigger>
        )
    }
}
